module.exports = __webpack_public_path__ + "static/szechenyi_logo-731dacf46badddd5f50fe46e6ca41172.jpg";